import { c as _c } from "react/compiler-runtime";
import { createContext, ReactNode, useCallback, useContext, useMemo, useRef, useState } from 'react';
type SecurityLoadingContextType = {
  /** Register a guard/provider loading state. Returns an unregister function. */
  registerLoader: (id: string, isLoading: boolean) => void;
  /** Whether any guard/provider is still loading */
  isAnyLoading: boolean;
};
const SecurityLoadingContext = createContext<SecurityLoadingContextType>({
  registerLoader: () => {},
  isAnyLoading: true
});
const SecurityLoadingProvider = t0 => {
  const $ = _c(9);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [loaders, setLoaders] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const loadersRef = useRef(t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {};
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const timingsRef = useRef(t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = (id, isLoading) => {
      if (loadersRef.current[id] === isLoading) {
        return;
      }
      if (isLoading && !timingsRef.current[id]) {
        timingsRef.current[id] = performance.now();
      } else {
        if (!isLoading && timingsRef.current[id]) {
          delete timingsRef.current[id];
        }
      }
      loadersRef.current = {
        ...loadersRef.current,
        [id]: isLoading
      };
      setLoaders(loadersRef.current);
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const registerLoader = t4;
  const stillLoading = Object.values(loaders).some(_temp);
  const isAnyLoading = stillLoading;
  let t5;
  if ($[4] !== isAnyLoading) {
    t5 = {
      registerLoader,
      isAnyLoading
    };
    $[4] = isAnyLoading;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== children || $[7] !== t5) {
    t6 = <SecurityLoadingContext.Provider value={t5}>{children}</SecurityLoadingContext.Provider>;
    $[6] = children;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};
const useSecurityLoading = () => {
  return useContext(SecurityLoadingContext);
};
export { SecurityLoadingProvider, useSecurityLoading };
function _temp(loading) {
  return loading;
}